<template>
  <div class="newlogin" data-automation="newlogin" @keydown.13="confirm">
    <!-- tab栏 -->
    <div class="newlogin-tabbox" :class="'newlogin-tabbox-' + formData.type">
      <div
        :class="['newlogin-tab', { 'newlogin-tab-active': formData.type === item.name }]"
        v-for="item in list"
        :key="item.name"
        @click="tabClick(item)"
      >
        {{ item.label }}
      </div>
    </div>

    <!-- 输入框 -->
    <div class="newlogin-form">
      <div v-if="isAccountLogin" key="newlogin-form-account">
        <div class="newlogin-form-item">
          <my-input
            v-model="formData.account"
            :placeholder="$t('HT.login.account.placeholder')"
            clearable
          ></my-input>
        </div>
        <div class="newlogin-form-item">
          <my-input
            v-model="formData.password"
            type="password"
            show-password
            :placeholder="$t('HT.rules.login.password')"
          ></my-input>
        </div>
      </div>

      <div v-else key="newlogin-form-phone">
        <div class="newlogin-form-item">
          <my-input v-model="formData.phone" :placeholder="$t('HT.rules.login.phone')" clearable>
            <template v-slot:prepend>
              <span class="pl16">+86</span>
            </template>
          </my-input>
        </div>
        <div class="newlogin-form-item">
          <my-input v-model="formData.imgCode" :placeholder="$t('HT.login.imgCode.placeholder')">
            <template v-slot:append>
              <img-verify ref="refImgVerify" v-model="prefix" />
            </template>
          </my-input>
        </div>
        <div class="newlogin-form-item">
          <my-input v-model="formData.code" :placeholder="$t('HT.rules.login.code')">
            <template v-slot:append>
              <time-button class="pr16" ref="time" text :time="120" @click="getCode"></time-button>
            </template>
          </my-input>
        </div>
      </div>

      <div class="newlogin-form-bottom">
        <div class="newlogin-errorbox">
          <span>{{ errorMsg }} </span>
          <router-link v-if="isShowErrorMsgRegister" to="/register">
            <ux-button type="primary" text>{{ $t('HT.login.register') }}&gt;&gt;</ux-button>
          </router-link>
        </div>
        <router-link v-if="isAccountLogin" to="/resetPass"
          ><span class="btn-forgot">{{ $t('HT.login.resetPass') }}</span></router-link
        >
      </div>
    </div>

    <!-- 底部按钮 -->
    <div class="newlogin-footer">
      <div :class="['newlogin-agreement', { 'animate-shakeX': showAnimate }]">
        <ux-checkbox class="agreement" v-model="agreement">
          <span>{{ $t('HT.login.agree') }}</span>
          <a :href="userAgreementUrl" target="_blank">
            <ux-button type="primary" text>{{ $t('HT.login.userAgreement') }}</ux-button>
          </a>

          <a :href="privacyAgreementUrl"target="_blank">
            <ux-button type="primary" text>{{ $t('HT.login.privacyAgreement') }}</ux-button>
          </a>
        </ux-checkbox>
      </div>
      <div class="newlogin-btnbox">
        <ux-button :disabled="isLoginDisabled" size="large" type="primary" @click="confirm"
          >{{$t('HT.login')}}</ux-button
        >
      </div>
      <div class="newlogin-btnbox">
        <router-link to="/register">
          <ux-button size="large" type="primary" plain>{{$t('HT.login.goRegister')}}</ux-button>
        </router-link>
      </div>
    </div>
  </div>
</template>
<script>
import timeButton from '../template/timeButton';
import imgVerify from '@c/imgVerify/imgVerify';
import myInput from './components/myInput';

export default {
  components: {
    timeButton,
    myInput,
    imgVerify
  },
  data() {
    return {
      list: [
        {
          label: this.$t('HT.login.phoneLogin'),
          name: 'phone'
        },
        {
          label: this.$t('HT.login.accountLogin'),
          name: 'account'
        }
      ],
      formData: {
        type: 'phone', // 选中的tab
        account: '', // 账户
        password: '', // 密码
        phone: '', // 手机
        code: '', // 验证码
        imgCode: '' // 图形验证码
      },
      rules: this.$rul.login(),
      islogin: false, // 是否在登录(防止回车的情况下发送多次),
      agreement: false, // 是否同意
      isShowErrorMsgRegister: false,
      errorMsg: '', // 错误信息
      showAnimate: false, // 显示动画
      showAnimateTimer: null, // 定时器
      prefix: '' // 图形验证码前缀
    };
  },
  computed: {
    // 是否账号密码登录
    isAccountLogin() {
      return this.formData.type === 'account';
    },
    // 是否禁用按钮
    isLoginDisabled() {
      const formData = this.formData;
      if (this.isAccountLogin) {
        return !formData.account || !formData.password;
      }
      return !formData.code || !formData.phone;
    },
    locale(){
      return this.$cookie.get('locale')
    },
    userAgreementUrl(){
      return this.getUrl(this.locale==='en'?102:100)
    },
    privacyAgreementUrl(){
      return this.getUrl(this.locale==='en'?103:101)
    }
  },

  methods: {
    getUrl(id){
      //100户协议_中文，101隐私协议_中文，102用户协议_英文，103隐私协议_英文
      return `https://opm.jimicloud.com/#/privacy?id=${id}&edition=1`
    },
    /**
     * 清除错误信息
     */
    clearErrorMsg() {
      this.errorMsg = '';
      this.isShowErrorMsgRegister = false;
    },
    /**
     * 切换登录方式
     * @param {Object} params 查询对象
     */
    tabClick(tab) {
      if (this.formData.type === tab.name) {
        return;
      }
      this.formData.type = tab.name;
      this.clearErrorMsg();
    },

    /**
     * 登录数据验证
     */
    confirm() {
      if (this.islogin || this.isLoginDisabled) return;
      const { account, password, code } = this.formData;
      // 密码登录
      if (this.isAccountLogin) {
        if (!account) {
          this.errorMsg = this.$t('HT.login.account.placeholder');
          return;
        }
        if (!password) {
          this.errorMsg = this.$t('HT.rules.login.password');
          return;
        }
      } else {
        // 手机登录
        const validatePhoneMsg = this.validatePhone();
        if (validatePhoneMsg) {
          this.errorMsg = validatePhoneMsg;
          return;
        }

        if (!code) {
          this.errorMsg = this.$t('HT.rules.login.code');
          return;
        }
      }
      if (!this.agreement) {
        this.errorMsg = this.$t('HT.login.text');
        if (this.showAnimate) return;
        this.showAnimate = true;
        this.showAnimateTimer = setTimeout(() => {
          this.showAnimate = false;
          clearTimeout(this.showAnimateTimer);
          this.showAnimateTimer = null;
        }, 1000);
        return;
      }
      this.clearErrorMsg();
      this.login();
    },

    /**
     * 登录接口
     */
    login() {
      this.islogin = true;
      const { account, password, code, phone } = this.formData;

      let postData = {};

      // 密码登录
      if (this.isAccountLogin) {
        postData = {
          account,
          password: this.$encryptDecs(password)
        };
      } else {
        // 手机登录
        postData = {
          phone,
          code
        };
      }

      this.$uxLoading.show();
      const fnLogin = this.isAccountLogin ? 'login' : 'loginSim';
      this.$api.login[fnLogin](postData, {
        hideMsg: true
      })
        .then((res) => {
          if (res.code == 10000) {
            this.$store.commit('saveToken', res.data.token); // 保存token
            this.$store.commit('saveUserData', res.data); // 保存用户信息
            this.$router.push('/home');
          }
        })
        .catch((err) => {
          const { sub_msg, sub_code } = err.response.data;
          // 用户不存在
          if (sub_code === 'not-found.account') {
            this.errorMsg = this.$t('HT.login.text1');
            this.isShowErrorMsgRegister = true;
            return;
          }
          if (sub_code === 'invalid.sms-code') {
            this.errorMsg = this.$t('HT.login.text2');
            return;
          }
          this.errorMsg = sub_msg;
        })
        .finally(() => {
          this.islogin = false;
          this.formData.code = '';
        });
    },

    /**
     * 获取验证码
     */
    getCode() {
      const validatePhoneMsg = this.validatePhone();
      if (validatePhoneMsg) {
        this.errorMsg = validatePhoneMsg;
        return;
      }

      const { phone, imgCode } = this.formData;

      if (!imgCode) {
        this.errorMsg = this.$t('HT.login.imgCode.placeholder');
        return;
      }

      this.clearErrorMsg();
      this.$uxLoading.show();

      const params = {
        phone,
        code: imgCode,
        prefix: this.prefix
      };

      this.$api.login
        .getIdentifyCode(params, { hideMsg: true })
        .then((res) => {
          if (res.code == 10000) {
            this.$refs.time.start();
          }
        })
        .catch((err) => {
          const { sub_msg } = err.response.data;
          this.errorMsg = sub_msg;
          this.$refs.refImgVerify.getKaptcha();
          this.formData.imgCode = '';
        });
    },

    // 验证手机
    validatePhone() {
      const { pattern, message } = this.rules.phone[1];
      const phone = this.formData.phone;
      if (!phone) {
        return this.$t('HT.rules.login.phone');
      }
      if (!pattern.test(phone)) {
        return message;
      }
      return '';
    }
  }
};
</script>

<style lang="scss" scoped>
.newlogin {
  padding: 80px 48px;

  .pr16 {
    padding-right: 16px;
  }

  .pl16 {
    padding-left: 16px;
  }

  .newlogin-tabbox {
    position: relative;
    width: 100%;
    text-align: left;
    height: 72px;

    &::before {
      content: '';
      position: absolute;
      top: 28px;
      left: 88px;
      width: 24px;
      height: 4px;
      background: $color-primary;
      transition: all 0.3s;
    }

    &.newlogin-tabbox-phone::before {
      left: 0;
    }

    &.newlogin-tabbox-account::before {
      left: 88px;
    }

    .newlogin-tab {
      display: inline-block;
      vertical-align: top;
      width: 88px;
      height: 24px;
      font-size: 16px;
      font-weight: 400;
      color: $color-text;
      line-height: 24px;
      cursor: pointer;

      &.newlogin-tab-active {
        font-size: 18px;
        color: $color-title;
        font-weight: 600;
      }
    }
  }

  .newlogin-form {
    position: relative;
    height: 228px;

    .newlogin-form-item {
      margin-bottom: 16px;
    }

    .newlogin-form-bottom {
      display: flex;
      justify-content: space-between;
    }

    .newlogin-errorbox {
      color: $color-error;
    }

    .btn-forgot {
      color: $color-text-secondary;
    }
  }

  .newlogin-footer {
    .newlogin-agreement {
      height: 16px;
      margin-bottom: 16px;

      ::v-deep .ux-checkbox .el-checkbox {
        color: $color-text-secondary;
      }
    }

    .newlogin-btnbox {
      margin-bottom: 8px;

      .ux-button {
        width: 100%;
      }
    }
  }
}
</style>
